module.exports = {
	"title": {
		"artist": "Escuche a {artistName} en Qobuz",
		"album": "Escuche el álbum {albumName} de {artistName} en Qobuz",
		"track": "Escuche {trackName} de {artistName} en Qobuz",
		"playlist": "Escuche la playlist {playlistName} de {ownerName} en Qobuz",
		"story": "Leer este artículo en Qobuz"
	},
	"buttons": {
		"listen": "Escuchar en Qobuz",
		"buy": "Comprar",
		"share": "Compartir",
		"download": "Probar gratis",
		"readmore": "Leer más",
		"showless": "Mostrar menos",
		"showmore": "Ver más",
		"morealbums": "Más álbumes en Qobuz",
		"moreplaylisttrack": "Descubra el resto en Qobuz",
		"readfocus": "Leer este Gran Angular en Qobuz",
		"seeSubscribes": "Ver las ofertas de suscripción",
		"cookies": "Configuración de las cookies"
	},
	"infos": {
		"trackCount": "{count} pistas",
		"label": "Sello: {label}",
		"composer": "Compositor: {composer}",
		"producers": "Producción",
		"mixers": "Mezcla/mastering",
		"diskCount": "{count} álbumes",
		"duration": {
			"long": "{hours}h {minutes}m",
			"short": "{minutes}m {seconds}s"
		},
		"playlist": {
			"private": "Privada",
			"public": "Pública"
		},
		"hires": "Alta calidad",
		"available": "Disponible en"
	},
	"share": {
		"twitter": {
			"track": "Escuche {title} de {artist} en Qobuz",
			"album": "Escuche {title} de {artist} en Qobuz",
			"artist": "Escuche a {artist} en Qobuz",
			"playlist": "Escuche {playlist} de {owner} en Qobuz",
			"story": "Leer este artículo en Qobuz"
		},
		"mail": {
			"track": {
				"subject": "¡{title} de {artist}está disponible en Qobuz!",
				"body": "Escuchar {title} de {artist} con Qobuz en alta calidad: {url}\n\nQobuz es el primer servicio de escucha y de descarga de música en alta calidad.\nMás informaciones y registro en Qobuz.com\n\n"
			},
			"album": {
				"subject": "¡{title} de {artist}está disponible en Qobuz!",
				"body": "Escuchar {title} de {artist} con Qobuz en alta calidad: {url}\n\nQobuz es el primer servicio de escucha y de descarga de música en alta calidad.\nMás informaciones y registro en Qobuz.com\n\n"
			},
			"artist": {
				"subject": "¡{artist} está en Qobuz!",
				"body": "Escuchar {artist} con Qobuz en alta calidad: {url}\n\nQobuz es el primer servicio de escucha y de descarga de música en alta calidad.\nMás informaciones y registro en Qobuz.com\n"
			},
			"playlist": {
				"subject": "¡{playlist} de {owner} está disponible en Qobuz!",
				"body": "Escuchar {playlist} de {owner} con Qobuz en alta calidad: {url}\n\nQobuz es el primer servicio de escucha y de descarga de música en alta calidad.\nMás informaciones y registro en Qobuz.com\n\n"
			},
			"story": {
				"subject": "{title}",
				"body": "Lea aquí {url}\n\nQobuz es el primer servicio para escuchar y descargar música en alta calidad.\nMás información e inscripciones en Qobuz.com\n\n"
			}
		},
		"popup": {
			"clickToCopy": "Haga click para copiar",
			"copy": "Copiar",
			"copied": "Copiado",
			"link": "Copie el siguiente vínculo para compartirlo"
		}
	},
	"tracklist": {
		"title": {
			"track": "Pista",
			"album": "Pistas del álbum",
			"artist": "Las mejores pistas",
			"artist_albums": "Álbumes",
			"playlist": "Pistas de la playlist"
		},
		"header": {
			"number": "#",
			"name": "Pista",
			"album": "Álbum",
			"artist": "Artista",
			"time": "Duración",
			"label": "Sello"
		},
		"media_count": "CD {mediaNumber}",
		"noTracks": "Ninguna pista disponible"
	},
	"story": {
		"404": {
			"title": "El artículo que ha solicitado no existe en su zona geográfica.",
			"description": "Volver a la página de inicio de la revista Qobuz"
		},
		"from": "Por {author}",
		"albumOverlay": "- {releaseYear} - {genre}",
		"joinQobuz": "Regístrate en Qobuz para leer el artículo completo...",
		"signUp": "Pruébelo gratis"
	},
	"playlist": {
		"from": "De {author}"
	},
	"album": {
		"by": "de",
		"publishedBy": "publicado en"
	},
	"notifications": {
		"nostream": "Los propietarios de los derechos no han permitido la escucha de esta pista"
	},
	"aside": {
		"title": "Acerca de"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/locales/es.json
// module id = 567
// module chunks = 0